<template>
    <el-row class="other-pane">
        <el-col :span="12">
            <div class="info-item">
                <span class="label">公司所在地：</span>
                <span class="value">{{ info.register_address || '--' }}</span>
            </div>
            <div class="info-item">
                <span class="label">广告主来源：</span>
                <span class="value">
                    {{ matchConfId(this.aderSource, info.origin) || '--' }}
                </span>
            </div>
            <!-- <div class="info-item">
                <span class="label">广告主类型：</span>
                <span class="value">{{ info.acc_type || '--' }}</span>
            </div> -->
            <div class="info-item">
                <span class="label">投放广告位：</span>
                <span class="value">
                    <el-tag type="success" v-for="item in adSlotTypes" :key="item">{{ item }}</el-tag>
                </span>
            </div>
        </el-col>
        <el-col :span="12">
            <div class="info-item">
                <span class="label">开户链接：</span>
                <span class="value">
                    <a :href="info.link || 'javascript:;'" target="_blank">
                        {{ info.link || '--' }}
                    </a>
                </span>
            </div>
            <div class="info-item">
                <span class="label">运营方：</span>
                <span class="value">
                    {{ matchConfId(this.operationSource, info.operator) || '--' }}
                </span>
            </div>
            <div class="info-item">
                <span class="label">创建时间：</span>
                <span class="value">{{ info.create_at || '--' }}</span>
            </div>
            <div class="info-item">
                <span class="label">备注：</span>
                <span class="value">{{ info.remarks || '--' }}</span>
            </div>
        </el-col>
    </el-row>
</template>
<script>
import { aderSource, operationSource } from '../../conf';

export default {
    name: 'DetailOtherPane',
    computed: {
        // 投放广告位
        adSlotTypes () {
            let result = [];
            const info = this.info;
            result = (info.adslot_type || '').split(',');

            if (info.adslot_type_ext) {
                result = [...result, info.adslot_type_ext];
            }
            // 最后一步,做个兜底方案,用'--'替换''
            if (result.length === 1 && result[0] === '') {
                result = ['--'];
            }

            return result;
        }
    },
    props: {
        info: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        aderSource,
        operationSource
    }),
    methods: {
        // 匹配相关text
        matchConfId (ori = [], id = '') {
            return (ori.find(i => i.id * 1 === id * 1) || {}).text || '';
        }
    }
};
</script>
<style lang="less" scoped>
.other-pane {
    /deep/ .el-tag--success {
        height: 24px;
        line-height: 22px;
        color: #2f9eff;
        background: rgba(242, 249, 255, 1);
        border-radius: 4px;
        border: 1px solid #2f9eff;
    }
    .info-item {
        padding-bottom: 24px;
        .label {
            display: inline-block;
            width: 130px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(144, 147, 153, 1);
        }
        .value {
            font-size: 14px;
            font-weight: 500;
            color: rgba(48, 49, 51, 1);

            /deep/ .el-tag {
                margin: 0 8px 8px 0;
            }

            a {
                color: #2f9eff;
                text-decoration: none;
            }
        }
    }
}
</style>
